/**
 * [ File :: MixinBuilder.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/lcCanvas/dev/scripts/MixinBuilder.js
 * @목적 : 다중상속을 지원하기 위한 클래스입니다.
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

class MixinBuilder {
	constructor(superclass) {
		this.superclass = superclass;
	}

	with(...mixins) {
		return mixins.reduce((c, mixin) => mixin(c), this.superclass);
	}
}

export default MixinBuilder;

// # how to call
// let mix = (superclass) => new MixinBuilder(superclass);

// # how to use
// class Second extends mix(Base).with(helloMethod, byeMethod)



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/scripts/MixinBuilder.js